module.exports = __webpack_public_path__ + "img/Esigns_Black.0a4f5736.svg";